import React from "react";

import { withDashboards } from "./../../../shared/containers/containerDashboards";
import { withSensors } from "./../../../shared/containers/containerSensors";

import IntelligenceSensorsList from "./intelligenceSensorsList";
import Notification from "./../../../shared/items/static/notification";
import Preloader from "./../../../shared/items/static/preloader";

import { getDashboard } from "../../../shared/services/sensors.data.service";
import messages from "./../../../shared/static.messages";
import { states } from "../../../reducers/queriesStates";

import styles from "./intelligenceResultContent.module.scss";

const IntelligenceResultContent = (props) => {
  const { dashboardsDataState, dashboardsData, sensorsDataState, sensorsData, isSensorsDataReady } = props;

  return (
    <div className={styles.IntelligenceResultContent}>
      {sensorsDataState === states.READY && dashboardsDataState === states.READY && isSensorsDataReady ? (
        <IntelligenceSensorsList data={getDashboard(dashboardsData, sensorsData.sensors)} />
      ) : sensorsDataState === states.READY && !isSensorsDataReady ? (
        <Notification type="warning">
          <p>{messages.noData}</p>
        </Notification>
      ) : sensorsDataState === states.FAILURE || dashboardsDataState === states.FAILURE ? (
        <Notification type="error">
          <p>{messages.error}</p>
        </Notification>
      ) : sensorsDataState === states.REQUEST ? (
        <div className={styles.container_preloader}>
          <Preloader />
        </div>
      ) : null}
    </div>
  );
};

export default withSensors(withDashboards(React.memo(IntelligenceResultContent)));
